import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { deleteRegistrosTemporarios } from 'api/capitalFlow';
import { openSnackbarMain } from 'components/Shared/openSnackbarMain';

const useModalTitulosCedidosHook = ({ onClose, setCarregarTela }) => {
  const [loadBtnConfirmar, setLoadBtnConfirmar] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();

  const suspendeCesssao = () => {
    deletarRegistrosTemporarios();
    setLoadBtnConfirmar(true);
    navigate('/capital-flow/nova-cessao', {
      state: { ...state, buscarDados: false }
    });

    setTimeout(() => {
      setLoadBtnConfirmar(false);
      setCarregarTela('NovaCessao');
      onClose();
    }, 500);
  };

  const deletarRegistrosTemporarios = () => {
    deleteRegistrosTemporarios()
      .catch(() => openSnackbarMain('Ocorreu um erro ao deletar os registros temporários', 'error'))
      .finally(() => {
        setLoadBtnConfirmar(false);
      });
  };

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    if (reason === 'escapeKeyDown') return;
    onClose();
  };

  return {
    loadBtnConfirmar,
    suspendeCesssao,
    handleClose
  };
};

export default useModalTitulosCedidosHook;
